import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconStepForwards: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconStepForwards"><Path fillRule="evenodd" clipRule="evenodd" d="M17.25 2.18945L21.3107 6.25011L17.25 10.3108L16.1893 9.25011L18.4393 7.00011H9.75C6.71243 7.00011 4.25 9.46255 4.25 12.5001C4.25 15.5377 6.71243 18.0001 9.75 18.0001H19V19.5001H9.75C5.88401 19.5001 2.75 16.3661 2.75 12.5001C2.75 8.63412 5.88401 5.50011 9.75 5.50011H18.4393L16.1893 3.25011L17.25 2.18945Z" fill="currentColor"/></CentralIconBase>;
});

export default IconStepForwards;
